<nav aria-label="Page actions">
  <div class="title">
    @if (isBackBtnVisible()) {
      <button nz-button nzType="text" (click)="onBackEvent()">
        <span nz-icon nzType="arrow-left"></span>
        <span>{{ 'global.back' | translate }}</span>
      </button>
    }

    @if (isTitleVisible() && !isBackBtnVisible()) {
      <h4 class="main-title">{{ titleI18nKey() | translate }}</h4>
    }
  </div>

  <div class="actions">
    <ng-content></ng-content>
  </div>
</nav>
